import React, { useEffect, useState } from 'react';
import "./ManageAllOrders.css";
import { Col, Container, Row, Table } from 'react-bootstrap';
import ManageOrders from '../ManageOrders/ManageOrders';
import Breadcrumb from '../Share/Breadcrumb/Breadcrumb';

const ManageAllOrders = () => {
    const [myOrders,setMyOrder] = useState([]);
    // get the order list id
    useEffect(()=> {
       fetch(`https://gruesome-beast-64485.herokuapp.com/myOrder`)
           .then(res => res.json())
           .then(data => {
               setMyOrder(data);
           })
   },[])

const userOrderDeleted = e => {
    const id = e;
    fetch(`https://gruesome-beast-64485.herokuapp.com/myOrder/${id}`,{
        method:'DELETE'
    })
    .then(res => res.json())
    .then(data => {
        if(data.deletedCount > 0){
            const updateUser = data.filter(user => user._id !== id);
            setMyOrder(updateUser);
            alert('Delete Successful');
            console.log(updateUser);
        }
        
    })
}
   
  
    return (
        <div className='myOrderPage'>
             <Breadcrumb>Manage All Orders</Breadcrumb>
             <Container>
                <h1>Orders Management</h1>
                <Row>
                    <Col>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>photos</th>
                                    <th>Travel Location</th>
                                    <th>Day</th>
                                    <th>Status : PENDING/OK</th>
                                    <th>Orders</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                   myOrders.map(orderList => <ManageOrders
                                     key={orderList._id} 
                                     order={orderList}
                                     deleteBtn={userOrderDeleted}
                                     ></ManageOrders> ) 
                                   
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ManageAllOrders;